<template>
  <RouterView />
</template>
<script setup>
import { useFirebaseStore } from '@/stores/firebase'
import { onBeforeMount } from 'vue'
const firebaseX = useFirebaseStore()
onBeforeMount(() => {
  firebaseX.listenAuthChanges();
})
</script>
<style lang="scss">
@import 'scss/main.scss';

#app {
  font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  min-width: 20rem;
}
</style>
